import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function Contracts() {
  const [text, setText] = useState('');
  const [signatureStatus, setSignatureStatus] = useState('');
  const [history, setHistory] = useState(() => {
    const saved = localStorage.getItem('khepri_contracts_history');
    return saved ? JSON.parse(saved) : [];
  });

  const templates = {
    service: {
      name: 'Услуги',
      subject: 'Консультационные услуги',
      amount: '500000',
    },
    supply: {
      name: 'Поставка',
      subject: 'Поставка товаров',
      amount: '800000',
    },
    nda: {
      name: 'NDA',
      subject: 'Соглашение о неразглашении',
      amount: '0',
    },
    rent: {
      name: 'Аренда',
      subject: 'Аренда помещения',
      amount: '120000',
    },
    contract: {
      name: 'Подряд',
      subject: 'Выполнение подрядных работ',
      amount: '1500000',
    },
    license: {
      name: 'Лицензия',
      subject: 'Лицензионное соглашение',
      amount: '300000',
    },
  };

  const [selectedTemplate, setSelectedTemplate] = useState('service');

  const generate = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const res = await fetch(API + '/docs/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.fromEntries(form)),
    });
    const data = await res.json();
    setText(data.text);
    setSignatureStatus('');

    const newRecord = {
      id: Date.now(),
      type: templates[selectedTemplate].name,
      customer: form.get('customer') || 'ООО Заказчик',
      subject: form.get('subject') || templates[selectedTemplate].subject,
      date: new Date().toLocaleString('ru-RU'),
    };
    const updated = [newRecord, ...history].slice(0, 10);
    setHistory(updated);
    localStorage.setItem('khepri_contracts_history', JSON.stringify(updated));
  };

  const signDocument = () => {
    setSignatureStatus('pending');
    setTimeout(() => {
      setSignatureStatus('done');
    }, 2000);
  };

  const downloadPDF = () => {
    if (!text) return;
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Договор_Khepri.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const deleteRecord = (id) => {
    const updated = history.filter(h => h.id !== id);
    setHistory(updated);
    localStorage.setItem('khepri_contracts_history', JSON.stringify(updated));
  };

  const clearHistory = () => {
    setHistory([]);
    localStorage.removeItem('khepri_contracts_history');
  };

  return (
    <div>
      <h2>Генератор договоров</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 12 }}>
        6 типов договоров с автоматической адаптацией под ваш налоговый режим
      </p>

      {/* Выбор шаблона */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        {Object.entries(templates).map(([key, tpl]) => (
          <button
            key={key}
            type="button"
            onClick={() => setSelectedTemplate(key)}
            style={{
              padding: '8px 16px',
              background: selectedTemplate === key ? '#6366F1' : '#1E293B',
              color: selectedTemplate === key ? '#fff' : '#94A3B8',
              border: selectedTemplate === key ? 'none' : '1px solid #334155',
              borderRadius: 20,
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            {tpl.name}
          </button>
        ))}
      </div>

      <form onSubmit={generate} style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 12 }}>
        <input type="hidden" name="contract_type" value={selectedTemplate} />
        <input name="customer" placeholder="Заказчик" defaultValue="ООО Заказчик" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <input name="executor" placeholder="Исполнитель" defaultValue="ООО Исполнитель" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <input name="subject" placeholder="Предмет договора" defaultValue={templates[selectedTemplate].subject} style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        {selectedTemplate !== 'nda' && (
          <input name="amount" placeholder="Сумма" defaultValue={templates[selectedTemplate].amount} style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        )}
        <input name="deadline" type="date" defaultValue="2026-12-31" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <button type="submit" style={{ padding: 12, background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>Сгенерировать</button>
      </form>

      {text && (
        <div style={{ marginTop: 16 }}>
          <pre style={{ padding: 16, background: '#1E293B', borderRadius: 8, whiteSpace: 'pre-wrap', fontSize: 13 }}>{text}</pre>

          <div style={{ marginTop: 12, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={signDocument}
              disabled={signatureStatus === 'pending' || signatureStatus === 'done'}
              style={{
                padding: '10px 24px',
                background: signatureStatus === 'done' ? '#10B981' : signatureStatus === 'pending' ? '#F59E0B' : '#6366F1',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: signatureStatus === 'done' ? 'default' : 'pointer',
                fontWeight: 600,
              }}
            >
              {signatureStatus === 'done' ? '✓ Подписан (УКЭП)' : signatureStatus === 'pending' ? 'Подписание...' : 'Подписать УКЭП'}
            </button>

            <button
              onClick={downloadPDF}
              style={{
                padding: '10px 24px',
                background: '#334155',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              📄 Скачать файл
            </button>

            {signatureStatus === 'done' && (
              <span style={{ color: '#10B981', fontSize: 13 }}>
                Документ юридически подписан. Подпись PKCS#7 прикреплена.
              </span>
            )}
          </div>

          <p style={{ color: '#94A3B8', fontSize: 12, marginTop: 8 }}>
            ⚠️ Демо подписи УКЭП. Полная интеграция с КриптоПРО появится в следующем обновлении.
          </p>
        </div>
      )}

      {history.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <h3>📋 История договоров</h3>
            <button onClick={clearHistory} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>
              Очистить
            </button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
                <th style={{ padding: 8 }}>Тип</th>
                <th style={{ padding: 8 }}>Заказчик</th>
                <th style={{ padding: 8 }}>Предмет</th>
                <th style={{ padding: 8 }}>Дата</th>
                <th style={{ padding: 8 }}>Действие</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h) => (
                <tr key={h.id} style={{ borderBottom: '1px solid #334155' }}>
                  <td style={{ padding: 8 }}>{h.type}</td>
                  <td style={{ padding: 8 }}>{h.customer}</td>
                  <td style={{ padding: 8, color: '#94A3B8' }}>{h.subject}</td>
                  <td style={{ padding: 8, color: '#94A3B8' }}>{h.date}</td>
                  <td style={{ padding: 8 }}>
                    <button onClick={() => deleteRecord(h.id)} style={{ background: 'none', border: 'none', color: '#EF4444', cursor: 'pointer', fontSize: 12 }}>
                      Удалить
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Contracts;